import Image from "@/components/Atoms/Image";
import CustomLink from "@/components/Atoms/CustomLink";
import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { ButtonMaster } from "@/components/Atoms/Buttons";
import {
	resolveButtonCustomIcon,
	resolveButtonIconColor,
} from "@/lib/functions";
import styles from "./index.module.scss";

type LimitedEditionCardProps = {
	title?: string;
	image?: any;
	href: string;
	cardBgColor?: string;
	textColor?: { hex?: string; cssRgb?: string };
	buttonConfig?: any;
};

export function LimitedEditionCard({
	title,
	image,
	href,
	cardBgColor,
	textColor,
	buttonConfig,
}: LimitedEditionCardProps) {
	return (
		<article
			className={styles.card}
			style={{ backgroundColor: cardBgColor }}
		>
			<CustomLink href={href} className={styles.cardLink}>
				<div className={styles.imageWrap}>
					<Image className={styles.image} data={image} />
				</div>
				{title && (
					<div className={styles.title}>
						<MultiPurposeParagraph
							type="limitedEditionCard"
							align="center"
							data={title}
							color={textColor}
						/>
					</div>
				)}
			</CustomLink>
			<div className={styles.buttonWrap}>
				<ButtonMaster
					anim="slideTop"
					type={buttonConfig?.buttonStyle}
					color={buttonConfig?.labelColor?.color}
					cta={buttonConfig?.typeColor?.color}
					customIcon={resolveButtonCustomIcon(buttonConfig)}
					customColor={resolveButtonIconColor(buttonConfig)}
					link={href}
				>
					+
				</ButtonMaster>
			</div>
		</article>
	);
}
